import { loadTranslations, translate } from '../i18n';
import { devLog, devWarn } from "../utils/devLog";

class GlobalTranslationStore {
  constructor() {
    this.translations = {};
    this.currentLanguage = 'en';
    this.isLoaded = false;
    this.loadPromise = null;
  }

  // Load translations for a specific language
  async loadLanguage(language) {
    if (this.loadPromise && this.currentLanguage === language) {
      return this.loadPromise;
    }

    this.loadPromise = this.loadTranslationsInternal(language);
    return this.loadPromise;
  }

  async loadTranslationsInternal(language) {
    try {
      devLog(`Loading translations for language: ${language}`);
      const translationData = await loadTranslations(language);
      this.translations = translationData;
      this.currentLanguage = language;
      this.isLoaded = true;
      devLog('Translations loaded successfully:', Object.keys(translationData));
      return translationData;
    } catch (error) {
      console.error('Failed to load translations:', error);
      this.isLoaded = false;
      throw error;
    }
  }

  // Translate function that works outside of React context
  translate(key, options = {}) {
    if (!this.isLoaded || !this.translations) {
      devWarn(`Translations not loaded. Returning key: ${key}`);
      return key;
    }

    const result = translate(key, options, this.translations, this.currentLanguage);
    return result;
  }

  // Get current language
  getLanguage() {
    return this.currentLanguage;
  }

  // Check if translations are loaded
  isReady() {
    return this.isLoaded && this.translations && Object.keys(this.translations).length > 0;
  }

  // Get raw translations object
  getTranslations() {
    return this.translations;
  }
}

// Create a singleton instance
const globalTranslationStore = new GlobalTranslationStore();

export default globalTranslationStore; 